module.exports = __webpack_public_path__ + "static/media/23.lucidchart.2cb61162.svg";